import { getUnixTime, parseISO } from 'date-fns'

type IntercomUser = {
  id: number
  fullname?: string
  email?: string
  created_at?: string
}

// Identify the signed-in user to the Intercom widget, which the server snippet
// now boots anonymously so the page stays edge-cacheable. created_at is sent as
// the unix seconds Intercom expects.
const identifyIntercomUser = (user: IntercomUser) => {
  if (typeof window.Intercom !== 'function') return

  window.Intercom('update', {
    user_id: user.id,
    ...(user.fullname && { name: user.fullname }),
    ...(user.email && { email: user.email }),
    ...(user.created_at && {
      created_at: getUnixTime(parseISO(user.created_at)),
    }),
  })
}

export { identifyIntercomUser }
